import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import { getComponentApps } from '@/services/source';
import PropertyName from './components/PropertyName';
import styles from './index.module.less';

interface Props {
  title: string;
  datas: any[];
}

const AppSetting: React.FC<Props> = (props: Props) => {
  const { title, datas } = props;

  const titleRender = (data: any) => {
    return <PropertyName property={data}></PropertyName>;
  };

  return (
    <div className={styles.patternWrap}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.body}>
        <Tree blockNode={true} treeData={datas} draggable={false} titleRender={titleRender} />
      </div>
    </div>
  );
};

export default React.memo(AppSetting);
